export const formatTeamUsersForSelect = users => {
  const formatted = users.map(user => {
    let label;

    if (user.name && user.email) {
      label = `${user.name} (${user.email})`;
    } else {
      label = user.email;
    }

    return {
      value: user.id,
      label,
    };
  });

  formatted.sort((a, b) => a.label.localeCompare(b.label));

  return formatted;
};
